import { billingApi } from '@/api';
import { userCan } from '@/lib/permission/userCan';
import store from '@/store';

export const checkBillingContact = async () => {
  if (!userCan.manageBilling()) return;
  const { data: billingDetails } = await billingApi.showBillingDetails({});
  store.commit('billing/HAS_BILLING_DETAILS', !!billingDetails);
};

export enum BillingDialogStageEnum {
  ChoosePlan,
  BillingDetails,
  PaymentMethod,
  Summary,
}
